import React from 'react'
import "./contact.css"
import {MdOutlineEmail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import {BsTwitter} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'


const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_53t2wlf', 'template_dmrgphs', form.current, 'LM3t5QK7ZHX3-eCMe')
      .then((result) => {
          console.log(result.text);
          e.target.reset();
      }, (error) => {
          console.log(error.text);
      });
  };

  return (

    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>adekolavictor51@gmail.com</h5>
            <a href="mailto:adekolavictor51@gmail.com"  rel="noreferrer"  target= "_blank">  Send a mail</a>
          </article>

          <article className='contact__option'>
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h5>Adekola Victor</h5>
            <a href="https://api.whatsapp.com/send?phone+23490481671"  rel="noreferrer"   target= "_blank">  Send a message</a>
          </article>

          <article className='contact__option'>
            <BsTwitter className='contact__option-icon' />
            <h4>Twitter</h4>
            <h5>Hot Reloader</h5>
            <a href="https://twitter.com/messages/compose?recipient_id=873452763467980800"  rel="noreferrer"  target= "_blank">  Send a mail</a>
          </article>
        </div>
        {/* END OF CONTACT OPTION */}
        <form ref={form} onSubmit = {sendEmail}>
          <input type="text" id='nameInput'  name='name' placeholder='Your Full Name' required />
          <input type="email" id='emailInput'  name='email' placeholder='Your Email' required />
          <textarea name="message" id='messageInput' rows="7" placeholder='Your Message'></textarea>
          <button  type='submit' className='btn btn-primary'>Send Message</button>
        </form>

      </div>
    </section>
  )
}

export default Contact